import * as _ from 'lodash';

export function fbDataPurifier(data) {
  if (_.isUndefined(data)) {
    return null;
  } else if (_.isPlainObject(data)) {
    const purifiedPairs = _.toPairs(data)
      .filter(p => (p[0] !== '$key'))
      .map((p) => {
        let v = p[1];

        if (_.isUndefined(v) || v === '') {
          v = null;
        } else if (_.isPlainObject(v)) {
          v = fbDataPurifier(v);
        }

        return [
          p[0],
          v,
        ];
      });

    return _.fromPairs(purifiedPairs);
  }

  return data;
}

export function deepEqual(x, y) {
  if ((typeof x === 'object' && x != null) && (typeof y === 'object' && y != null)) {
    const xProps = Object.keys(x);
    if (xProps.length !== Object.keys(y).length) {
      return false;
    }

    for (let i = 0; i < xProps.length; i += 1) {
      const prop = xProps[i];
      // eslint-disable-next-line no-prototype-builtins
      if (y.hasOwnProperty(prop)) {
        if (!deepEqual(x[prop], y[prop])) {
          return false;
        }
      } else {
        return false;
      }
    }

    return true;
  } else if (x !== y) {
    return false;
  }

  return true;
}

export function msToDays(ms = 0) {
  return ms > 0 ? ms / (1000 * 60 * 60 * 24) : 0;
}

export function daysToMs(ms = 0) {
  return ms > 0 ? ms * 1000 * 60 * 60 * 24 : 0;
}

export function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}



// WEBPACK FOOTER //
// ./src/utils.js